<div class="invoice-container">
    <div class="invoice-header">
        <img src="/assets/income.png" alt="Company Logo">
        <h1>{{ 'expenses & revenue' | translate }} </h1>
    </div>

    <div class="categoryContainer noPrint">
        <button class="btn btn-primary first-btn " (click)="addExpenses()">
            {{ 'Add expenses' | translate }}
        </button>
        <button class="btn btn-primary first-btn " (click)="addRevenues()">
            {{ 'Add Revenue' | translate }}
        </button>
        <!-- <button (click)="calculateTotal()" class="first-btn btn btn-primary">
            {{ 'Calculate Total' | translate }}
        </button> -->
        <button onclick="window.print();" class="first-btn  noPrint btn btn-primary">{{ 'Print' | translate }}</button>
        <br>
        <button *ngIf="isAdmin" class="btn btn-primary first-btn " (click)="getArchivedBalances()">
            {{ 'deleted archive' | translate }}
        </button>

        <div *ngIf="isAdmin" class="dropdown filter" style="display: inline;">
            <button class="btn btn-secondary dropdown-toggle btn-primary first-btn" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">{{ "Users" | translate }} </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="userFilter(el.id)"
                        *ngFor="let el of allUsers; let i = index">{{el.username}} </a></li>

            </ul>
        </div>
                   <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="{{ 'Search' | translate }}" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-primary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>
    </div>


    <div class="row noPrint">
        <div class="col-6">
            <h2>{{ "byday" | translate }}</h2>

            <input class="input day" [(ngModel)]="day" (change)="getByDate()" type="date" placeholder="date" />


        </div>
        <div class="col-6">
            <h2>{{ "bymonth" | translate }}</h2>

            <div class="d-flex gap-2">
                <!-- اختيار السنة -->
                <select class="form-select" [(ngModel)]="selectedYear" (change)="getByMonth()">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>

                <!-- اختيار الشهر -->
                <select class="form-select" [(ngModel)]="selectedMonth" (change)="getByMonth()">
                    <option *ngFor="let month of months" [value]="month.value">
                        @if(isAr){
                        {{ month.name }}
                        }
                        @else{
                        {{ month.name_en }}
                        }
                    </option>
                </select>
            </div>
        </div>
    </div>


    <div class="invoice-details row">
        <app-loading *ngIf="contentReady"></app-loading>
        <div class="col-sm-12 col-md-6">

            <table class="invoice-table">
                <thead>
                    <tr>
                        <th>
                            - <strong>{{ 'total' | translate }} {{ 'expenses' | translate }} :</strong> {{ expenseTotal
                            | number:'1.2-2' }} {{ 'egp' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ex of expenses">
                        <td>
                            <span style="color: red;">{{ 'amount' | translate }} : {{ ex.amount }} {{ 'egp' |
                                translate}}</span>
                            <br>
                            <b> {{ 'reason' | translate }} </b> : {{ ex.note }} {{ translateTypeEnum(ex.type) }}
                            <br>
                            <b> {{ 'admin' | translate }} </b> - {{ ex.username }}
                            <br>
                            {{formatDate(ex.created_at)}}
                            @if(ex.deleted_by != null) {
                            <br>
                            <b> {{ 'deleted by' | translate }} </b> : {{ex.deleted_by}}
                            }
                            @else{
                            <button (click)="delete(0,ex.id)" class="btn noPrint btn-primary delete"><i class="fa-solid fa-xmark"></i></button>
                            <button (click)="edit(0,ex.id)" class="btn noPrint btn-primary delete"> <i class="fa-solid fa-pen-to-square"></i></button>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-sm-12 col-md-6">
            <table class="invoice-table">
                <thead>
                    <tr>
                        <th>
                            <strong>{{ 'total' | translate }} {{ 'Revenue' | translate }} :</strong> {{ revenueTotal |
                            number:'1.2-2' }} {{ 'egp' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let Revenue of Revenues">
                        <td>
                            <span style="color: green; text-align: left;">{{ 'amount' | translate }} : {{ Revenue.amount}} {{ 'egp' | translate}}</span>
                            <br>
                            <b> {{ 'reason' | translate }} </b> : {{ Revenue.note }} {{ translateTypeEnum(Revenue.type)
                            }}
                            <br>
                            <b> {{ 'admin' | translate }} </b> - {{ Revenue.username }}
                                 <br>
                            {{formatDate(Revenue.created_at)}}
                            @if(Revenue.deleted_by != null) {
                            <br>
                            <b> {{ 'deleted by' | translate }} </b> : {{Revenue.deleted_by}}
                            }
                            @else{
                            <button (click)="delete(1,Revenue.id)" class="btn noPrint btn-primary delete"> <i
                                    class="fa-solid fa-xmark"></i></button>
                            <button (click)="edit(1,Revenue.id)" class="btn noPrint btn-primary delete"> <i class="fa-solid fa-pen-to-square"></i></button>
                            
                                }

                        </td>

                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</div>

<div *ngIf="showFinPopUp" class="popup">

    <div class="maindev">
        <button (click)='close()' class="close btn btn-primary"> {{ "close" | translate }} </button>

        <img src="/assets/income.png">

        <div class="form d-flex flex-column flex-sm-row justify-content-center">
            <div class="form-group">
                <label class="label" for="quantity">{{ 'amount' | translate }} </label>
                <input class="input" type="text" id="not_payed" [(ngModel)]="amount"
                    placeholder="{{ 'amount' | translate }} " />
            </div>
            <div class="form-group">
                <label class="label" for="quantity">{{ 'note' | translate }}</label>
                <input class="input" type="text" id="payed" [(ngModel)]="note"
                    placeholder="{{ 'note' | translate }} " />
            </div>
        </div>
        <button (click)="onSubmit()" type="submit" class="submit-btn btn btn-primary">
            {{ "Submit" | translate }}
        </button>



    </div>
</div>